import { FileText, ExternalLink } from 'lucide-react'
import { invoiceDocumentUrl, type Invoice } from '@/api/billing'

/**
 * Invoices are a currency surface by definition — each one carries the tax
 * breakdown and the GSTIN captured when it was issued.
 */
export default function InvoicesList({ invoices }: { invoices: Invoice[] }) {
  return (
    <div className="card" style={{ padding: '1.25rem' }}>
      <h3 style={{ margin: '0 0 0.875rem', fontSize: '1.0625rem' }}>Invoices</h3>
      {!invoices.length ? (
        <p style={{ color: 'var(--color-text-secondary)', fontSize: '0.9375rem', margin: 0 }}>
          No invoices yet. One is issued for every payment.
        </p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {invoices.map((inv) => (
            <div
              key={inv.invoice_number}
              style={{
                display: 'flex', alignItems: 'center', gap: '0.75rem',
                padding: '0.625rem 0', borderTop: '1px solid var(--color-border)',
              }}
            >
              <FileText size={16} style={{ color: 'var(--color-text-secondary)', flexShrink: 0 }} />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: '0.9375rem', fontWeight: 500 }}>{inv.invoice_number}</div>
                <div style={{ fontSize: '0.8125rem', color: 'var(--color-text-secondary)' }}>
                  {inv.issued_at ? new Date(inv.issued_at).toLocaleDateString(undefined, {
                    day: 'numeric', month: 'short', year: 'numeric',
                  }) : ''}
                  {inv.tax_minor > 0 && ` · incl. ${inv.display.tax} tax`}
                </div>
              </div>
              <div style={{ fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}>{inv.display.total}</div>
              <a
                className="btn btn-secondary"
                href={invoiceDocumentUrl(inv.invoice_number)}
                target="_blank"
                rel="noreferrer"
                style={{ padding: '0.25rem 0.625rem', fontSize: '0.8125rem', gap: '0.25rem' }}
              >
                <ExternalLink size={12} /> View
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
